import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, roles, crm }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Laden...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (crm && !user.crm) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
